import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 215px;
  width: 100%;
  max-width: 370px;

  @media (max-width: 768px) {
    margin-top: 0;
    place-self: center;
    min-height: calc(100vh - 356px);
    height: 100%;
  }
`;

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;

  span {
    font-size: 0.75rem;
    color: #5e5e5e;
    margin-bottom: 22px;
    color: ${({ theme }) => theme.colors.gray};
    display: flex;
    align-items: center;
  }

  h1 {
    font-size: 1.4375rem;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.blue};
  }

  h2 {
    font-size: 0.9375rem;
    margin-bottom: 18px;
    color: ${({ theme }) => theme.colors.gray};
    line-height: 30px;
    font-weight: 400px;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const ContainerButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;
`;

export const Paragraph = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray};
  font-family: "Mangueira bold";
  margin: 0;
  margin-bottom: 15px;
`;
export const WrapSearchDocument = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: flex-end;
  color: #0b24fb;
  margin-top: 5px;
  margin-bottom: 16px;

  div {
    cursor: pointer;
  }

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const SearchDocumentText = styled.span`
  text-decoration-line: underline;
  cursor: pointer;
`;

export const SearchDocumentIcon = styled.div`
  margin-left: 10px;
  width: 20px;
  height: 20px;
  background: #97f8fb;
  border-radius: 50%;
  font-weight: 500;
`;
